import type { ImageLoaderProps } from 'next/image';

import { createContentfulAssetUrl } from '~/contentful/utils/asset';

export function imageLoader({ src, width, quality }: ImageLoaderProps): string {
  return createContentfulAssetUrl({
    src,
    width,
    quality: quality || 75,
    format: 'webp',
  });
}
